var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{class:{
    'vs-snackbar': true,
    [`vs-${_vm.type}`]: true,
    'vs-sticky': _vm.sticky,
  },attrs:{"value":_vm.value,"absolute":_vm.sticky,"color":_vm.$options.barColor(_vm.type),"timeout":_vm.$options.timeoutDuration(_vm.keepOpen),"data-test":"snackbar","rounded":"pill"},on:{"input":_vm.$listeners.input},scopedSlots:_vm._u([(!_vm.keepOpen)?{key:"action",fn:function(){return [_c('v-icon',{staticClass:"vs-snack-close",attrs:{"small":""},on:{"click":function($event){return _vm.$listeners.input(false)}}},[_vm._v(" close ")])]},proxy:true}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }